import { TokenService } from '@/services/auth/tokenService';
import { useEffect, useState } from 'react';
import type { ReactElement } from 'react';
import { Navigate } from 'react-router';

export const PrivateRoute = ({ children }: { children: ReactElement }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const tokenService = TokenService.getInstance();
    const tokens = tokenService.getStoredTokens();
    const authenticated = tokens && !tokenService.isTokenExpired();
    setIsAuthenticated(!!authenticated);
  }, []);

  // Show nothing while checking authentication
  if (isAuthenticated === null) {
    return null;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};
